const baseConstants = require('./base')

const bip44Constants = [...baseConstants]

// SLIP-0044 lists 0x8000022a as reserved (`'---'`). Flare claims this slot in
// practice, so we override the reserved entry in place. Pushing a second row
// for the same constant would create a duplicate that breaks forward-search
// lookups (e.g. `Array.find`/`Array.findIndex` would return the reserved row
// rather than the intended FLR row).
const flareIndex = bip44Constants.findIndex(([constant]) => constant === 0x80_00_02_2a)
if (flareIndex === -1) {
  throw new Error('Expected reserved bip44 constant 0x8000022a to exist in base array')
}

bip44Constants[flareIndex] = [0x80_00_02_2a, 'FLR', 'Flare']

module.exports = bip44Constants
